import { useState } from "react";
import VisualizadorFoto from "./VisualizadorFoto";
import { urlDaFoto } from "./url";

/*
  Miniatura da foto do usuário para as listagens.

  Só a bolinha: o nome fica por conta de quem usa, porque cada tabela monta essa
  célula de um jeito (ID embaixo, turma ao lado, etc.). Guarda o próprio estado
  da ampliação para a tela que usa não precisar controlar nada.
*/

/**
 * JSDoc explícito: é .jsx consumido também por .tsx.
 *
 * @param {{
 *   foto?: string | null,
 *   nome?: string,
 *   tamanho?: number,
 * }} props
 */
function MiniaturaFoto({ foto = null, nome = "", tamanho = 36 }) {
  const [ampliada, setAmpliada] = useState(false);

  const url = urlDaFoto(foto);

  const base = {
    width: tamanho,
    height: tamanho,
    borderRadius: "50%",
    overflow: "hidden",
    /* sem isto a bolinha é o primeiro a ceder espaço quando a coluna aperta */
    flexShrink: 0,
    border: "1px solid #dee2e6",
    background: "#f1f3f5",
  };

  /* sem foto: mantém o mesmo espaço, para os nomes ficarem alinhados na coluna */
  if (!url) {
    return (
      <div
        style={{
          ...base,
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        <i className="fas fa-user text-muted" style={{ fontSize: tamanho / 2.6 }} />
      </div>
    );
  }

  return (
    <>
      <button
        type="button"
        title="Ver foto ampliada"
        onClick={() => setAmpliada(true)}
        style={{ ...base, padding: 0, cursor: "pointer" }}
      >
        <img
          src={url}
          alt={nome || "Foto do usuário"}
          style={{ width: "100%", height: "100%", objectFit: "cover" }}
        />
      </button>

      <VisualizadorFoto
        url={ampliada ? url : null}
        nome={nome}
        onFechar={() => setAmpliada(false)}
      />
    </>
  );
}

export default MiniaturaFoto;
